
import * as d3 from "d3";
import $ from "jquery";
import _ from "underscore";

export const SankeyBarChart = function (domId, svgId, dataset, options, total, footerClickCallback) {

    const svgSelector = `#${svgId}`;

    // container for exposure to the outside world
    let self = {};

    // when we resize the window we simply repaint, we wrap
    // in underscores deferred and debounce methods to avoid
    // eating windows CPU and paints
    // TODO: disabled as it wasn't behaving properly
    // $(window).on('resize', _.debounce(function () {
    //     _.defer(function () {
    //         $(domId).html('');
    //         self.render(domId, dataset, options);
    //     });
    // }, 50));

    // core rendering logic which is invoked as the window is resized
    // or when the viz is first loaded
    self.render = function (domId, dataset, options, total) {

        const max_value = total;

        // calculate abandonment rate per step to show the user in header/footer
        _.each(_.range(dataset.length - 1), function (i) {
            var exit_count = dataset[i].enter.value - dataset[i + 1].enter.value;
            dataset[i].exit.value = exit_count;
            dataset[i].exit.rate = exit_count / dataset[i].enter.value;
        });

        // calc aggregate conversion rate to show the user in header/footer
        _.each(_.range(1, dataset.length), function (i) {
            var rate = dataset[i].enter.value / dataset[0].enter.value;
            dataset[i].enter.rate = rate;
        });

        // options the user can use to modify the presentation of the
        // snakey barchat
        options = _.defaults(options || {}, {
            height: 200,
            padding: {
                top: 20,
                right: 20
            },
            range: {
                gap: 0.6,
                padding: 0.5
            },
            axis: {
                y: {
                    ticks: 4,
                    color: "#cccccc",
                    stroke: "#eeeeee",
                    format: ",.0f"
                },
                x: {
                    stroke: "#ddd",
                    dash_array: ("3, 3")
                }
            },
            bar: {
                stroke: "#6596EB",
                fill: "#739FEE"
            },
            sankey: {
                color: "#e9e9e9",
                opacity: 0.4
            }
        });

        // height and width, width is always assumed to be
        // the width of the container to elastically and responsively
        // scale to the device width and screen width
        var w = $(domId).width();
        var h = options.height || $(domId).height();

        // ranges/gaps/padding along x
        var xaxis_range_gap = d3.scale
            .ordinal()
            .domain(_.range(dataset.length)) // # of columns
            .rangeRoundBands([0, w - options.padding.right], options.range.gap, options.range.padding); // range, gap, pad

        // ===============================
        // TABLE WIDTH - We want to render columns
        // that match the columns in the SVG barchar so
        // we can align our table headers and footers to
        // these to give some KPIs and describe the data.
        // ===============================
        var table_column_width = function (d, i) {
            var me = xaxis_range_gap(i).toFixed(0);
            if (i < dataset.length - 1) {
                var next = xaxis_range_gap(i + 1).toFixed(0);
                return (next - me).toFixed(0) + 'px';
            } else {
                return (w - me).toFixed(0) + 'px';
            }
        };

        // ===============================
        // BARCHART HEADER
        // ===============================
        const header = d3.select(domId).select('.header');

        const headerSelection = header.selectAll("span")
            .data(dataset, (d) => d.enter.label + d.enter.value);

        headerSelection.enter()
            .append('span')
            .style("left", function (d, i) {
                var x = xaxis_range_gap(i).toFixed(0);
                return x + 'px';
            })
            .style("width", table_column_width)
            .style("position", "absolute")
            .append('div')
            .classed('th', true)
            .append('label')
            .text(d => d.enter.label)
            .append('em')
            .classed('value', true)
            .text(d => d3.format(",.0f")(d.enter.value))
            .append('em')
            .classed('rate', true)
            .text(d => d.enter.rate ? d3.format(",.1%")(d.enter.rate) : '');

        headerSelection.exit().remove();

        // ===============================
        // BARCHART FOOTER
        // ===============================

        const footer = d3.select(domId).select('.footer');

        const footerSelection =
            footer.selectAll("span")
            .data(_.range(dataset.length - 1));

        footerSelection.enter()
            .append("span")
            .classed("altola-insights", true)
            .style("left", (d, i) => `${xaxis_range_gap(i).toFixed(0)}px`)
            .style("width", table_column_width)
            .style("position", "absolute")
            .on("click", (d, i) => {
                //step.bind(null, playbackFinishedCallback)
                footerClickCallback(d);
                //console.log('clicked:' + d + 'i:' + i);
            });

        footerSelection.exit().remove();

        // ===============================
        // XAXIS
        // ===============================

        const lines = d3.select(svgSelector).select(".x-lines");

        const xLineSelection = lines.selectAll("line.x")
            .data(_.range(dataset.length));

        xLineSelection.enter()
            .append("line")
            .attr("class", "x")
            .attr("x1", function (d, i) {
                return xaxis_range_gap(i);
            })
            .attr("y1", 0)
            .attr("y2", h)
            .attr("x2", function (d, i) {
                return xaxis_range_gap(i);
            })
            .style("stroke", options.axis.x.stroke)
            .style("stroke-dasharray", options.axis.x.dash_array);

        xLineSelection.exit().remove();

        // ===============================
        // YAXIS
        // ===============================

        const ylines = d3.select(svgSelector).select(".y-lines");

        const yaxis = d3.scale.ordinal()
            .domain(_.range(options.axis.y.ticks))
            .rangeBands([0, h], 0, 0);

        const yLinesSelection = ylines
            .selectAll("line.y")
            .data(_.range(options.axis.y.ticks));

        yLinesSelection
            .enter()
            .append("line")
            .attr("class", "y")
            .attr("x1", 0)
            .attr("y1", function (d, i) {
                return yaxis(i);
            })
            .attr("y2", function (d, i) {
                return yaxis(i);
            })
            .attr("x2", w)
            .style("stroke", options.axis.y.stroke);

        yLinesSelection.exit().remove();

        const yText = d3.select(svgSelector).select(".y-text");

        const bar_height_fx = d3.scale.linear()
            .domain([0, max_value])
            .range([0, h])
            .nice();

        const yTextSelection = yText
            .selectAll("text")
            .data(_.range(options.axis.y.ticks + 1));

        yTextSelection.enter()
            .append("text")
            .attr("class", "y")
            .attr("x", 2)
            .attr("y", function (d, i) {
                if (i == options.axis.y.ticks) {
                    return h - 3;
                } else {
                    var y = yaxis(i) - 3;
                    return y;
                }
            })
            .text(function (d, i) {
                if (i == options.axis.y.ticks) {
                    return '0';
                } else {
                    var frmt = d3.format(options.axis.y.format);
                    var y = h - yaxis(i);
                    var v = bar_height_fx.invert(y);
                    return frmt(Math.round(v));
                }
            })
            .style("fill", options.axis.y.color);

        yTextSelection.exit().remove();

        // ===============================
        // BARS
        // ===============================

        const barSelection = d3.select(svgSelector)
            .selectAll("rect")
            .data(dataset, (d) => d.enter.label + d.enter.value);

        barSelection.enter()
            .append("rect")
            .attr("x", function (d, i) {
                return xaxis_range_gap(i);
            })
            .attr("y", function (d) {
                return (h - bar_height_fx(d.enter.value));
            })
            .attr("width", xaxis_range_gap.rangeBand())
            .attr("height", function (d) {
                return bar_height_fx(d.enter.value)
            })
            .attr("fill", function (d) {
                return options.bar.fill;
            })
            .style("stroke", options.bar.stroke);

        barSelection.exit()
            .remove();

        // ===============================
        // SANKEY FILL
        // Drawing our connections between the bars to visualize 
        // the movement between the bars.
        // ===============================
        const edgeSelection = d3.select(svgSelector)
            .select(".edges")
            .selectAll(".edge")
            .data(_.initial(dataset), (d) => d.enter.label + d.enter.value);

        edgeSelection
            .enter()
            .append("polygon")
            .attr("class", "edge")
            .attr("points", function (this_datapoint, i) {
                const next_datapoint = dataset[i + 1];
                const y1 = h - bar_height_fx(this_datapoint.enter.value);
                const y2 = h - bar_height_fx(next_datapoint.enter.value);
                const x1 = xaxis_range_gap(i);
                const x2 = xaxis_range_gap(i + 1);

                return [
                    x1 + xaxis_range_gap.rangeBand() + 1, y1, // top right of this bar
                    x2, y2, // top left of next bar
                    x2, h + 1, // bottom left of next bar
                    x1 + xaxis_range_gap.rangeBand() + 1, h + 1 // bottom right of this bar
                ].join(" ");
            })
            .style("fill", options.sankey.color)
            .style("opacity", options.sankey.opacity);

        edgeSelection.exit().remove();
    };

    self.render(domId, dataset, options, total);

    return self;
};


// WEBPACK FOOTER //
// ./src/charts/SankeyBarChart.js